const REGULAR_OPTIONS = {
  STANDARD: {
    title: 'Standard',
    price: false,
    freeMention: null,
    tooltip: 'Lightweight and timeless, with a square&nbsp;flap.',
  },
  LETTERPRESS: {
    title: 'Luxe Cotton',
    price: false,
    freeMention: null,
    tooltip: 'Made of 100% cotton paper, extra thick with a square&nbsp;flap.',
  },
};

const DELUXE_OPTIONS = {
  STANDARD: {
    title: 'Deluxe',
    price: true,
    freeMention: 'Free',
    tooltip: 'Thicker than our standard envelopes, with an elegant Euro&nbsp;flap.',
  },
  LETTERPRESS: {
    title: 'Deluxe',
    price: true,
    freeMention: 'Free with letterpress',
    tooltip: 'Made of thick non-cotton paper, with an elegant Euro&nbsp;flap.',
  },
};

export const REGULAR_LISTS_OPTIONS = [REGULAR_OPTIONS.STANDARD, DELUXE_OPTIONS.STANDARD];
export const LETTERPRESS_LISTS_OPTIONS = [REGULAR_OPTIONS.LETTERPRESS, DELUXE_OPTIONS.LETTERPRESS];



// WEBPACK FOOTER //
// ./src/cards/components/Customization/common/ColorPicker/constants.js